"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextCopy = void 0;
var _react = _interopRequireDefault(require("react"));
var _TextCopyB2B = require("./TextCopyB2B");
var _excluded = ["type"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var MAP_TEXTCOPY_TYPE = {
  'b2b': _TextCopyB2B.TextCopyB2B
};
var TextCopy = exports.TextCopy = function TextCopy(_ref) {
  var type = _ref.type,
    moreProps = _objectWithoutProperties(_ref, _excluded);
  var defaultType = 'b2b';
  var Component = MAP_TEXTCOPY_TYPE[type] || MAP_TEXTCOPY_TYPE[defaultType];
  return /*#__PURE__*/_react["default"].createElement(Component, moreProps);
};